import { env } from '@/env';

/**
 * "Is a newer build live?" for the installed app. A home-screen app can stay
 * open for days and keeps running the code it started with; every build
 * writes `/version.json` with its id (vite.config.ts), and this compares it
 * with the id baked into the running bundle.
 *
 * Fails quiet: dev (no build id), a network error, an HTML fallback page or a
 * malformed file all answer "no update" - never a false alarm.
 */
export const RUNNING_BUILD_ID: string = env.VITE_APP_BUILD_ID ?? '';

export const isNewerBuildLive = async (
  running: string = RUNNING_BUILD_ID,
  fetcher: typeof fetch = fetch,
): Promise<boolean> => {
  if (!running) return false;
  try {
    // Query string too: any cache in between must not answer for the origin.
    const res = await fetcher(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return false;
    const data = (await res.json()) as { buildId?: unknown };
    return typeof data.buildId === 'string' && data.buildId !== '' && data.buildId !== running;
  } catch {
    return false;
  }
};
